/* eslint-disable import/no-cycle */
import React from "react"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { defineMessages, useIntl } from "react-intl"
import { reset } from "redux-form"
// Material Ui
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
// ## //
import widgetController from "../../../api/widgetSlice"
import WidgetPropertiesForm from "./WidgetPropertiesForm"
import { WidgetDataType } from "./WidgetPropTypes"
import { actions as notifier } from "../../../component/notifier"
import { words } from "../../../i18n/lstrings"
import DialogTitleWithClose from "../../../component/dialog/DialogTitleWithClose"
import { WIDGET_SEPARATION_MODES } from "../../../widgets/separationModes"

const messages = defineMessages({
  saveSuccess: {
    id: "widget.save.message",
    defaultMessage: "Widget successfully saved"
  }
})

const { actions } = widgetController

const WidgetEditorModal = ({ isOpen, onClose, widget }) => {
  const dispatch = useDispatch()
  const { formatMessage: format } = useIntl()

  const handleSave = (values) => {
    const updatedWidget = {
      id: widget._id,
      widget: values.widget,
      defaultDashboardUuid: values.defaultDashboardUuid,
      defaultBookmarkName: values.defaultBookmarkName,
      separationMode: values.separationMode,
      alias: values.alias,
      screen: values.screen,
      scope: values.scope,
      period: values.advancedOptions?.period
      // defaultParamStr: values.defaultParams
    }

    if (
      values.separationMode ===
      WIDGET_SEPARATION_MODES.SEPARATE_WIDGET_BY_VISITOR_PROFILE
    ) {
      updatedWidget.widgetsByVisitorProfile = values.widgetsByVisitorProfile
    }

    // do not refresh widget data using flag to false
    const saveWidgetAction = actions.save(updatedWidget, false)
    dispatch(saveWidgetAction).then(() => {
      dispatch(notifier.enqueueSuccess(messages.saveSuccess))
      dispatch(reset("NewWidgetForm"))
      onClose()
    })
  }

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="lg">
      <DialogTitleWithClose onClose={onClose}>
        {format(widget._id ? words.edit : words.add)}
      </DialogTitleWithClose>
      <DialogContent>
        <WidgetPropertiesForm handleSave={handleSave} initialValues={widget} />
      </DialogContent>
    </Dialog>
  )
}

WidgetEditorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  widget: WidgetDataType.isRequired
}
WidgetEditorModal.defaultProps = {
  isOpen: false
}

export default WidgetEditorModal
